/**
 * Club (offensive card) definitions (HANDOFF §3.3) — Agent B (shot pipeline).
 *
 * Pure data only — no logic, no DOM. The numbers live in ./constants.ts
 * (CLUB_DEFS); this module projects them into the {@link Club} shape and offers
 * a lookup. Agent A consumes CLUBS to deal hands in the reducer.
 */
import type { Club } from './types.ts';
import { CLUB_DEFS } from './constants.ts';

/** The deck of offensive clubs (§3.3), sourced from the constants table. */
export const CLUBS: readonly Club[] = CLUB_DEFS.map((c) => ({
  id: c.id,
  name: c.name,
  rarity: c.rarity,
  cost: c.cost,
  power: c.power,
  accuracy: c.accuracy,
  control: c.control,
  forgiveness: c.forgiveness,
  spin: c.spin,
  flight: c.flight,
  shape: c.shape,
}));

/** Look up a club by id. Returns undefined if not found. */
export function getClub(id: string): Club | undefined {
  return CLUBS.find((c) => c.id === id);
}
